export const enum StringBundle {
  ATF,
  BTF,
}
